import {RelatedPartyDto} from '@dto/entities/related-party-dto.model';
import {RelatedPartyViewModel} from './related-party-view.model';
import {inject, Injectable} from '@angular/core';
import {DateConverterService} from '@shared/services/date-converter.service';
import {IconViewModel} from '@components/ui/table-template/models/icon-view-model';
import {IconSize} from '@components/ui/table-template/enums/icon-size.enum';
import {RelatedPartyListDto} from '@dto/entities/related-party-list.dto';
import {IconColour} from '@components/ui/table-template/enums/icon-colour.enum';

@Injectable({
  providedIn: 'root'
})
export class RelatedPartyConverterService {
  private readonly dateConverterService = inject(DateConverterService);

  public convertRelatedPartyListDtoToRelatedPartyViewModels(relatedPartyListDto: RelatedPartyListDto): RelatedPartyViewModel[] {
    return relatedPartyListDto.relatedParties.map(relatedPartyDto => this.convertRelatedPartyDtoToRelatedPartyViewModel(relatedPartyDto));
  }

  private convertRelatedPartyDtoToRelatedPartyViewModel(relatedPartyDto: RelatedPartyDto): RelatedPartyViewModel {

    if (!(relatedPartyDto.EntityName)) {
      relatedPartyDto.EntityName = '';
    }

    if (!(relatedPartyDto.EntityForenames)) {
      relatedPartyDto.EntityForenames = '';
    }

    if (relatedPartyDto.EntityName === '' && relatedPartyDto.EntityForenames === '') {
      relatedPartyDto.EntityForenames = 'No name available';
    }

    if (relatedPartyDto.DateResigned === '0001-01-01') {
      relatedPartyDto.DateResigned = null;
    }
    const iconImageUrl = this.getRelatedPartyIconUrl(relatedPartyDto.BaseType);

    return {
      icon: new IconViewModel(iconImageUrl, relatedPartyDto.BaseType, 0, IconSize.Medium, IconColour.IconPrimary),
      name: `${relatedPartyDto.EntityForenames} ${relatedPartyDto.EntityName}`.trim(),
      description: relatedPartyDto.Description,
      dateAppointed: this.dateConverterService.toDate(relatedPartyDto.DateAppointed),
      dateResigned: (relatedPartyDto.DateResigned ? this.dateConverterService.toDate(relatedPartyDto.DateResigned) : null),
      baseType: relatedPartyDto.BaseType
    };
  }

  private getRelatedPartyIconUrl(baseType: string): string {
    const baseUrl = 'assets/icons/related-party-types';
    switch (baseType) {
      case 'Related':
        return `${baseUrl}/related.svg`;
      case 'Officer/Principal':
        return `${baseUrl}/officer.svg`;
      case 'Shareholder':
        return `${baseUrl}/shareholder.svg`;
      default:
        return `${baseUrl}/other.svg`;
    }
  }
}
